import amioWebappHttpClient from '@/services/amio-api/http/amio-webapp.http-client'
import { handleSingleDataResponse, handleListResponse, handleError } from '@/services/amio-api/utils/request-utils'
import merge from 'ramda/src/merge'

class UserService {
  constructor() {
    this.path = '/users'
  }

  list(params = {}, ignoredHttpStatuses = []) {
    const _params = merge({page: 0, per_page: parseInt(process.env.VUE_APP_LIST_MAX_SIZE)}, params)
    return amioWebappHttpClient
      .get(this.path, {params: _params})
      .then(handleListResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  get(id, ignoredHttpStatuses = []) {
    return amioWebappHttpClient
      .get(`${this.path}/${id}`)
      .then(handleSingleDataResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  create(data, ignoredHttpStatuses = []) {
    return amioWebappHttpClient
      .post(this.path, data)
      .then(handleSingleDataResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  update(id, data, ignoredHttpStatuses = []) {
    return amioWebappHttpClient
      .patch(`${this.path}/${id}`, data)
      .then(handleSingleDataResponse)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }

  delete(id, ignoredHttpStatuses = []) {
    return amioWebappHttpClient
      .delete(`${this.path}/${id}`)
      .catch(error => handleError(error, ignoredHttpStatuses))
  }
}

export default new UserService()
